(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soje-bundle-sizes')) {
  customElements.define('soje-bundle-sizes', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.bundle = this.previousElementSibling;
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.toggle = this.querySelector('input');
      this.rows = this.querySelector('.soje-size-rows');
      this.summary = this.querySelector('.soje-size-summary');
      this.fr = document.documentElement.lang.startsWith('fr');
      this.sizes = [];
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.toggle.addEventListener('change', () => this.render(), options);
      this.form.addEventListener('variant:change', () => { if (!this.toggle.checked) this.sizes = []; this.render(); }, options);
      this.bundle.addEventListener('change', () => this.render(), options);
      this.bundle.addEventListener('click', () => requestAnimationFrame(() => this.render()), options);
      // The theme keeps its standard add-to-cart, errors, cart drawer and discounts.
      // Normalize only the mixed-size payload when the theme creates FormData.
      this.form.addEventListener('formdata', (event) => {
        if (!this.toggle.checked || this.quantity < 2) return;
        const data = event.formData;
        [...data.keys()].forEach(key => { if (key === 'id' || key === 'quantity' || /^items\[/.test(key)) data.delete(key); });
        this.selectedVariants().forEach((variant, index) => {
          data.append(`items[${index}][id]`, variant.id);
          data.append(`items[${index}][quantity]`, '1');
        });
      }, options);
      this.observer = new MutationObserver(() => this.render());
      this.observer.observe(this.bundle, {childList: true, subtree: true});
      this.render();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
    currentVariant() {
      return this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]')?.value) || this.variants[0];
    }
    selectedVariants() {
      const current = this.currentVariant();
      return this.sizes.slice(0, this.quantity).map(size => this.variants.find(v => v.option1 === size && v.option2 === current.option2 && v.option3 === current.option3) || current);
    }
    render() {
      const checked = this.bundle.querySelector('input.prvw_pair:checked');
      this.quantity = Number(checked?.value || 1);
      this.hidden = !checked || this.quantity < 2;
      const current = this.currentVariant();
      const choices = this.variants.filter(v => v.option2 === current.option2 && v.option3 === current.option3);
      for (let i = 0; i < this.quantity; i++) {
        if (!this.toggle.checked || !this.sizes[i]) this.sizes[i] = current.option1;
      }
      this.rows.hidden = !this.toggle.checked;
      const signature = JSON.stringify([this.quantity, this.toggle.checked, this.sizes, current.option2]);
      if (signature === this.signature) return;
      this.signature = signature;
      this.rows.replaceChildren();
      if (this.toggle.checked) {
        for (let i = 0; i < this.quantity; i++) {
          const row = document.createElement('fieldset');
          const legend = document.createElement('legend');
          legend.textContent = `${this.fr ? 'Collant' : 'Pair'} ${i + 1}`;
          row.append(legend);
          const buttons = document.createElement('div');
          choices.forEach(variant => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = variant.option1;
            button.disabled = !variant.available;
            button.setAttribute('aria-pressed', String(this.sizes[i] === variant.option1));
            button.addEventListener('click', () => {
              this.sizes[i] = variant.option1;
              this.render();
              this.rows.querySelectorAll('fieldset')[i]?.querySelector('[aria-pressed="true"]')?.focus({preventScroll:true});
            });
            buttons.append(button);
          });
          row.append(buttons);
          this.rows.append(row);
        }
      }
      const counts = {};
      this.sizes.slice(0, this.quantity).forEach(size => counts[size] = (counts[size] || 0) + 1);
      this.summary.textContent = `${this.fr ? 'Votre sélection' : 'Your selection'} : ` + Object.entries(counts).map(([size, count]) => `${count} × ${size}`).join(' · ');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soje-collants-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soje-collants-description')) {
    customElements.define('soje-collants-description', class extends HTMLElement {
      connectedCallback() {
        this.observer = new MutationObserver(() => this.enhance());
        this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        this.enhance();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      enhance() {
        const content = this.querySelector('.station-tabs.is-ready .station-tabs-default-tabpanel .station-tabs-tabcontent');
        if (!content || content.querySelector('.soje-description-disclosure')) return;
        const paragraphs = [...content.querySelectorAll('p')].filter(p => p.textContent.trim());
        if (paragraphs.length < 3) return;
        this.observer.disconnect();
        const range = document.createRange();
        range.selectNodeContents(content);
        range.setStartAfter(paragraphs[1]);
        const remainder = range.extractContents();
        const details = document.createElement('details');
        details.className = 'soje-description-disclosure';
        const summary = document.createElement('summary');
        for (const [name, label, icon] of [['more', this.dataset.more, '+'], ['less', this.dataset.less, '−']]) {
          const span = document.createElement('span');
          span.className = `soje-description-${name}`;
          span.textContent = `${label} `;
          const symbol = document.createElement('span');
          symbol.setAttribute('aria-hidden', 'true');
          symbol.textContent = icon;
          span.append(symbol);
          summary.append(span);
        }
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'soje-description-close';
        close.textContent = this.dataset.less;
        close.addEventListener('click', () => {
          details.open = false;
          summary.focus();
        });
        details.append(summary, remainder, close);
        content.append(details);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
